import React, { useState, useEffect } from "react";
import StepCircle from "../StepCircle";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Stepper,
  Step,
  StepLabel,
  Grid,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import api from "../../api";

const steps = ["Detalles de la Infracción", "Asignar Vehículo"];

const AgregarInfraccion = ({ vehiculo, handleClose, onUpdate }) => {
  const [step, setStep] = useState(0);
  const [vehiculos, setVehiculos] = useState([]);
  const [isStep1Valid, setIsStep1Valid] = useState(false);

  const [infraccion, setInfraccion] = useState({
    descripcion: "",
    fecha: "",
    monto: "",
    vehiculo_id: "",
    conductor_id: "",
    pagada: false,
    codigo_multa: "",
    lugar_radicacion: "",
  });

  // Fetch vehicles
  useEffect(() => {
    api
      .get("vehiculos/")
      .then((response) => setVehiculos(response.data))
      .catch(() => alert("Error al cargar vehículos."));
  }, []);

  // Pre-fill if vehiculo prop is passed
  useEffect(() => {
    if (vehiculo) {
      setInfraccion((prev) => ({
        ...prev,
        vehiculo_id: vehiculo.id,
      }));
    }
  }, [vehiculo]);

  // Validate Step 1
  useEffect(() => {
    const { descripcion, fecha, monto } = infraccion;
    setIsStep1Valid(descripcion && fecha && monto);
  }, [infraccion]);

  const handleChange = (e) => {
    setInfraccion({ ...infraccion, [e.target.name]: e.target.value });
  };

  const handleNext = () => {
    if (vehiculo) {
      // Skip Step 2 and submit
      handleSubmit(new Event("submit"));
    } else {
      setStep((prev) => prev + 1);
    }
  };

  const handleBack = () => setStep((prev) => prev - 1);

  const handleSubmit = (e) => {
    e.preventDefault();

    const vehiculoSeleccionado = vehiculos.find(
      (v) => v.id === infraccion.vehiculo_id
    );

    const conductorAsignado = vehiculoSeleccionado?.conductor_asignado?.id || null;

    const infraccionData = {
      descripcion: infraccion.descripcion,
      fecha: infraccion.fecha,
      monto: infraccion.monto,
      vehiculo: infraccion.vehiculo_id,
      conductor: conductorAsignado,
      pagada: infraccion.pagada || false,
      codigo_multa: infraccion.codigo_multa || "",
      lugar_radicacion: infraccion.lugar_radicacion || "",
    };

    console.log("Submitting infracción data:", JSON.stringify(infraccionData, null, 2));

    api
      .post("infracciones/", infraccionData)
      .then((response) => {
        console.log("Infracción agregada correctamente:", response);
        alert("Infracción agregada correctamente");
        if (onUpdate) {
          onUpdate(response.data); // send the new data to parent
        }
        handleClose();
      })
      .catch((error) => {
        console.error("Error al agregar infracción:", error.response || error);
        if (error.response) {
          console.log("Error status:", error.response.status);
          console.log("Detalles del error:", error.response.data);
        }
        alert("Hubo un error al agregar la infracción.");
      });
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
      <Typography variant="h6" style={{ color: "#152d51", fontWeight: "bold" }}>
        Agregar Infracción
      </Typography>

      <Stepper activeStep={step} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel StepIconComponent={StepCircle}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {step === 0 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={6}>
            <TextField
              label="Código de Multa"
              name="codigo_multa"
              value={infraccion.codigo_multa}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Lugar de Radicación"
              name="lugar_radicacion"
              value={infraccion.lugar_radicacion}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Descripción"
              name="descripcion"
              value={infraccion.descripcion}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Monto"
              name="monto"
              type="number"
              value={infraccion.monto}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Fecha"
              name="fecha"
              type="date"
              value={infraccion.fecha}
              onChange={handleChange}
              fullWidth
              required
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={infraccion.pagada}
                  onChange={(e) =>
                    setInfraccion({ ...infraccion, pagada: e.target.checked })
                  }
                  name="pagada"
                />
              }
              label="Pagada"
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleNext}
              sx={{ background: "#152d51" }}
              disabled={!isStep1Valid}
            >
              {vehiculo ? "Agregar Infracción" : "Siguiente"}
            </Button>
          </Grid>
        </Grid>
      )}

      {!vehiculo && step === 1 && (
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel style={{ background: "white" }}>Vehículo</InputLabel>
              <Select name="vehiculo_id" value={infraccion.vehiculo_id} onChange={handleChange}>
                <MenuItem value="">Sin vehículo</MenuItem>
                {vehiculos.map((vehiculo) => (
                  <MenuItem key={vehiculo.id} value={vehiculo.id}>
                    {vehiculo.patente} - {vehiculo.marca} {vehiculo.modelo}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" fullWidth onClick={handleBack}>
              Atrás
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button type="submit" variant="contained" color="primary" fullWidth sx={{ background: "#152d51" }}>
              Agregar Infracción
            </Button>
          </Grid>
        </Grid>
      )}
    </form>
  );
};

export default AgregarInfraccion;
